import styled from "styled-components";
import { Small } from "@/lib/styles/text";

export const Container = styled.div`
`;

export const Heading = styled(Small)`
  display: block;
  font-weight: 700;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  text-align: center;
  margin: 1rem auto;
  padding: 1rem 0;
  text-transform: uppercase;
  font-size: 1.25rem;
`;

export const ProductsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 3.75rem;

  ${({ theme }) => theme.mediaQueries.laptop} {
    grid-template-columns: repeat(4, 1fr);
    grid-row-gap: 6.25rem;
  }

  ${({ theme }) => theme.mediaQueries.desktop} {
    margin: 0 auto;
  }
`;
